import CallForImpact from './container';

export default CallForImpact;



// WEBPACK FOOTER //
// ./src/routes/CallForImpact/index.js